import { FormControl, MenuItem, Select } from "@mui/material";
import { useMemo } from "react";
import { styles } from "./tasks";
import ConciergeFilterComponent from "../concierge/ConciergeFilterComponent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ALL_MILESTONES, FUTURE_WEEKS, NEXT_WEEK, NO_DUE_DATE, THIS_WEEK } from "../dashboard/taskMetricsComponent";
import { MileStoneCount } from "../../../utils/homeSiteTaskMetrics/homeSiteTaskMetrics";
import { STANDARD_HEIGHT_OF_DROPDOWN } from "../../../utils/constants";
import { thinDarkScrollbar } from "../../../utils/scrollbarStyles";

interface ITaskFiltersProps {
    selectedDropdownMilestone: string;
    setSelectedDropdownMilestone: (milestone: string) => void;
    timeFrame: string;
    setTimeFrame: (timeFrame: string) => void;
    milestoneCounts: Record<string, MileStoneCount>;
    milestoneOrder: string[];
    applyDynamicFilters: (filters: { [key: string]: string | null }) => void;
}

const TaskFilters: React.FC<ITaskFiltersProps> = ({ applyDynamicFilters, selectedDropdownMilestone, setSelectedDropdownMilestone,
    timeFrame,
    setTimeFrame,
    milestoneCounts,
    milestoneOrder
}) => {

    const timeFrameOptions = useMemo(
        () => [
            { value: THIS_WEEK, label: THIS_WEEK },
            { value: NEXT_WEEK, label: NEXT_WEEK },
            { value: FUTURE_WEEKS, label: FUTURE_WEEKS },
        ],
        []
    );

    // Deduplicate milestone names to prevent duplicates in dropdown
    const uniqueMilestoneOrder = useMemo(() => {
        const seen = new Set<string>();
        return milestoneOrder.filter(name => {
            if (seen.has(name)) {
                return false;
            }
            seen.add(name);
            return true;
        });
    }, [milestoneOrder]);

    const renderMilestoneMenuItem = (name: string, count: MileStoneCount) => (
        <MenuItem key={name} value={name}>
            {name} <span style={styles.boldText}>{count.numHomesites}{count.numOverdue > 0 ? <span style={{ color: "#C93939" }}> ({count.numOverdue})</span> : ''}</span>
        </MenuItem>
    );


    return (
        <div style={styles.filterContainer}>
            <ConciergeFilterComponent applyDynamicFilters={applyDynamicFilters} />
            {selectedDropdownMilestone !== NO_DUE_DATE && (
                <FormControl style={styles.formControl}>
                    <Select
                        sx={styles.select}
                        value={timeFrame}
                        IconComponent={(props) => (
                            <KeyboardArrowDownIcon
                              {...props}
                              sx={{ color: "#1C2B36", fontSize: 30 }}
                            />
                          )}
                        onChange={(e) => setTimeFrame(e.target.value)}
                    >
                        {timeFrameOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
            <FormControl style={styles.formControl}>
                <Select
                    sx={styles.select}
                    MenuProps={{
                        PaperProps: {
                        sx: {
                            maxHeight: STANDARD_HEIGHT_OF_DROPDOWN,
                            overflowY: "auto",
                            ...thinDarkScrollbar,
                        },
                        },
                    }}
                    value={selectedDropdownMilestone}
                    IconComponent={(props) => (
                        <KeyboardArrowDownIcon
                          {...props}
                          sx={{ color: "#1C2B36", fontSize: 30 }}
                        />
                      )}
                    onChange={(e) => setSelectedDropdownMilestone(e.target.value)}
                    defaultValue={ALL_MILESTONES}
                >
                    {renderMilestoneMenuItem(ALL_MILESTONES, milestoneCounts[ALL_MILESTONES] || { numHomesites: 0, numOverdue: 0 })}
                    {uniqueMilestoneOrder.map(name => 
                        renderMilestoneMenuItem(name, milestoneCounts[name] || { numHomesites: 0, numOverdue: 0 })
                    )}
                    {renderMilestoneMenuItem(NO_DUE_DATE, milestoneCounts[NO_DUE_DATE] || { numHomesites: 0, numOverdue: 0 })}
                </Select>
            </FormControl>
        </div>
    );
};

export default TaskFilters;